import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// Importar i18n de forma assíncrona
import('./i18n').catch(err => {
  console.warn('Aviso ao carregar i18n:', err);
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  document.body.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;"><div style="text-align:center;"><h1>Erro ao carregar DeuConta</h1><p>Elemento root não encontrado. Tente recarregar a página.</p></div></div>';
  throw new Error('Root element not found');
}

try {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
} catch (error) {
  console.error('Erro ao inicializar aplicação:', error);
  rootElement.innerHTML = '<div style="display:flex;align-items:center;justify-content:center;height:100vh;font-family:sans-serif;"><div style="text-center;"><h1>Erro ao carregar DeuConta</h1><p>Ocorreu um erro ao inicializar a aplicação. Tente recarregar a página.</p></div></div>';
}
